import React from 'react';
import PropTypes from 'prop-types';
import endpoints from '../../define/endpoints';

const CircleCard = ({ size, image, caption, link, disabled = false }) => {
  let imagePath = '';
  if (image) {
    imagePath = image.startsWith('https')
      ? image
      : `${endpoints.bucket}${image}`;
    imagePath = `${imagePath}?crop=1:1,smart&width=88&dpr=2`;
  }

  const content = (
    <>
      <img
        className={`circle-card__image circle-card__image--${size}`}
        src={imagePath}
        loading="lazy"
      />
      <div className={`circle-card__caption circle-card__caption--${size}`}>
        {caption}
      </div>
    </>
  );

  return (
    <div className="circle-card">
      {disabled ? (
        <div
          className={`circle-card__wrapper circle-card__wrapper--${size} circle-card__disabled`}
        >
          {content}
        </div>
      ) : (
        <a
          className={`circle-card__wrapper circle-card__wrapper--${size}`}
          href={link}
        >
          {content}
        </a>
      )}
    </div>
  );
};

export const CircleCardSizes = {
  regular: 'regular',
  small: 'small',
};

CircleCard.propTypes = {
  size: PropTypes.string,
  image: PropTypes.string,
  caption: PropTypes.string,
  link: PropTypes.string,
  disabled: PropTypes.bool,
};

CircleCard.defaultProps = {
  size: CircleCardSizes.regular,
  disabled: false,
};

export default CircleCard;
